module.exports = __webpack_public_path__ + "img/file-document-edit-outline.f8a5f685.svg";